

@if (displayLoader) {
  <mat-spinner [diameter]="60" [strokeWidth]="5"></mat-spinner>
} @else {
  <a class="compass__back__link"
    [routerLink]="getBackUrl()"
    [queryParams]="getBackQueryParams()"
    aria-label="précédent">
    <mat-icon svgIcon="back"></mat-icon>
    <span>{{ goBackLinkName }}</span>
  </a>
  <section>
    <app-compass-card
      class="compass-card--resource-infos compass-card--resource compass-card--resource-{{getResourceType(resource, true)}}">
      <div data-header class="app-compass-card__header">
        <h3>{{ getResourceType(resource) }}</h3>
      </div>
      <div data-body class="app-compass-card__body">
        <div [innerHTML]="resource.get('description')"></div>
      </div>
      <div data-footer class="app-compass-card__footer">
        @for (media of resource.get('medias'); track media) {
          @if (isMediaImage(media)) {
            <button (click)="onOpenImageClick(media)"
              class="app-compass-card__footer-media">
              <mat-icon svgIcon="image"></mat-icon>
              <span>image</span>
            </button>
          }
          @if (isMediaVideo(media)) {
            <button (click)="onOpenVideoClick(media)"
              class="app-compass-card__footer-media">
              <mat-icon svgIcon="video"></mat-icon>
              <span>video</span>
            </button>
          }
          @if (isMediaPdf(media)) {
            <button (click)="onOpenPdfClick(media)"
              class="app-compass-card__footer-media">
              <mat-icon svgIcon="pdf"></mat-icon>
              <span>pdf</span>
            </button>
          }
        }
      </div>
    </app-compass-card>
  </section>
}
